<template>
    <el-dialog
            :title="!dataForm.id ? '新增' : '修改'"
            :close-on-click-modal="false"
            :visible.sync="visible"
            style="text-align: left">
        <el-form :model="dataForm" :rules="rules" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
                 label-width="150px">
            <el-form-item label="日期" prop="month">
                <el-date-picker
                v-model="dataForm.month"
                type="date"
                :disabled="dataForm.id != undefined && dataForm.id != ''"
                value-format="yyyy-MM-dd"
       placeholder="选择月">
       </el-date-picker>
            </el-form-item>
            <el-form-item label="残保金" prop="cbj">
                <el-input-number v-model="dataForm.cbj"  :precision="4" :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="折旧及摊销" prop="zjjtx">
                <el-input-number v-model="dataForm.zjjtx"  :precision="4"  :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="劳防用品" prop="lfyp">
                <el-input-number v-model="dataForm.lfyp"  :precision="4"  :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="其他费用" prop="qtfy">
                <el-input-number v-model="dataForm.qtfy"   :precision="4"  :step="1" :min="0"></el-input-number>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
    </el-dialog>
</template>

<script>
    import Template from "../../../template";
    export default {
        components: {Template},
        data () {
            const validateNumber = (rule, value, callback) => {
                var patrn = /^\d+(\.\d+)?$/;
                if (!patrn.exec(value)) {
                    callback(new Error('请填写数字'))
                } else {
                    callback()
                }
            }
            return {
                //表单验证规则
                rules: {
                    month: [{required: true, trigger: 'blur', message: '请选择日期'}],
                    bmid: [{required: true, trigger: 'blur', message: '请选择部门'}],
                    zbsbsj: [],
                    zbxbsj: [],
                    wbsbsj: [],
                    wbxbsj: [],
                    ybsbsj: [],
                    ybxbsj: [],
                    expireTime: [{required: true, trigger: 'blur', message: '请输入过期时间'}],
                    temp: [{required: true, trigger: 'blur', message: '请选择是否为临时岗点'}],
                },
                bcxxForm:{
                    morbc:{time:['','']},
                    aftbc:{time:['','']},
                    evebc:{time:['','']}
                },
                visible: false,
                deptdisable:false,
                updated:false,
                depts:[],
                dataForm: {
                    id: '',
                    month: '',
                    cbj: '',
                    zjjtx: '',
                    qtfy: '',
                    lfyp:''
                }
            }
        },
        methods: {
            init (id) {
                this.updated = false
                this.dataForm.id = id
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if(this.dataForm.id) {
                        this.updated = true
                        this.$http({
                            url: '/bjba/gscb/info/'+this.dataForm.id,
                            method: 'get'
                        }).then(({data}) => {
                            this.dataForm   = data.data
                           
                        })
                    }
                })

            },
            getDepts() {
                let that = this;
                this.$request.get('/bjba/kqtj/getFirstMentForUser',{
                    params: {
                        userid:this.$store.getters.username
                    }

                }).then(res => {
                    that.depts = res.data
                    if(this.depts && this.depts[0]) {
                        var zzdyqc = this.$store.getters.user.zzdyqc;
                        if(zzdyqc != this.CONST_ZN_BM) {
                            var zw = this.$store.getters.user.zw;

                            if(zw) {
                                if(zw=='01'||zw=='02'||zw=='03') {
                                    this.form.bmid = that.depts[0].bmid
                                    this.deptdisable = true
                                }
                            }

                        }
                    }
                })
            },
            // 表单提交
            // 表单提交
            dataFormSubmit () {

                this.$refs['dataForm'].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: `/bjba/gscb/save`,
                            method: 'post',
                            data: Object.assign(this.dataForm)
                        }).then(({data}) => {
                            if (data && data.code === 200) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success',
                                    duration: 1500
                                })
                                this.visible = false
                                this.$emit
                                ('refreshDataList')
                            } else if(data && data.code === 500) {
                                this.$message({
                                    message: data.message,
                                    type: 'error',
                                    duration: 1500
                                })
                            }
                        })
                    }
                })
            }
        }
    }
</script>
